import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import DayCalendar from "./DayCalendar";
import ListCalendar from "./ListCalendar";
import WeekCalendar from "./WeekCalendar";
import MonthCalendar from "./MonthCalendar";
import CalendarHeader from "./CalendarHeader";
import Filter from "../../components/elements/Filter";
import ButtonSchedule from "../../components/Buttons/Buttons";
import NextClass from "../../components/TableClass/NextClass";
import ModalSchedule from "../../components/ScheduleModals/ModalSchedule";

import {
  applyCalendarFilters,
  handleSetCalendarScreen,
  handleCalendarInitialParams,
} from "../../store/middleware/calendar.middleware";
import { getNextClass } from "../../store/middleware";
import { setNextClasses, setNextClassesWA } from "../../store/slices/generics.slice";

function CalendarIndex() {
  let { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.userReducer);
  const { nextClassesWA } = useSelector((state) => state.genericReducer);
  const { activeScreen, selectedStart, selectedEnd, selectedDateTime } = useSelector((state) => state.calendarReducer);

  const [openSchedule, setOpenSchedule] = useState(false);
  const [filter, setFilter] = useState({
    type: "",
    planId: "",
    status: "",
    student: "",
    teacher: "",
    lingoLanguageId: "",
    endAt: moment().format("YYYY-MM-DD"),
    startAt: moment().format("YYYY-MM-DD"),
  });

  const atualDate = moment(new Date());

  const handleOpenSchedule = () => setOpenSchedule(true);

  const handleCloseSchedule = () => setOpenSchedule(false);

  const handleAcceptClass = async () => {
    const weekStart = moment(selectedStart).clone().startOf("week");
    const weekEnd = moment(selectedStart).clone().endOf("week");
    if (state?.weekScreen) {
      await dispatch(handleSetCalendarScreen("week", weekEnd, weekStart));
    } else {
      await dispatch(handleCalendarInitialParams("list", filter.startAt, filter.endAt, true));
    }
  };

  const applyFilters = (e) => {
    e.preventDefault();

    if (!filter.startAt || !filter.endAt) {
      return alert("Por favor, confira o campo de data");
    }

    dispatch(applyCalendarFilters(filter, activeScreen));
  };

  const inputChange = (e, name) => {
    if (e.name || e.value) {
      setFilter((state) => ({ ...state, [e.name]: e.value }));
    } else {
      const { value } = e.target;
      setFilter((state) => ({ ...state, [name]: value }));
    }
  };

  const clearFilters = async (e) => {
    e.preventDefault();
    await setFilter({
      startAt: moment().format("YYYY-MM-DD"),
      endAt: moment().format("YYYY-MM-DD"),
      lingoLanguageId: "",
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
    handleAcceptClass();
  };

  const viewHandler = async (activeScreen) => {
    const monthStart = moment(selectedStart).clone().startOf("month");
    const monthEnd = moment(selectedEnd).clone().endOf("month");

    const weekStart = moment(selectedStart).clone().startOf("week");
    const weekEnd = moment(selectedEnd).clone().endOf("week");
    switch (activeScreen) {
      case "month":
        dispatch(setNextClassesWA([]));
        await dispatch(handleSetCalendarScreen(activeScreen, monthEnd, monthStart));
        break;
      case "week":
        dispatch(setNextClassesWA([]));
        await dispatch(handleSetCalendarScreen(activeScreen, weekEnd, weekStart));
        break;
      case "day":
        dispatch(setNextClassesWA([]));
        await dispatch(handleSetCalendarScreen(activeScreen, atualDate, atualDate, true));
        break;
      case "list":
        dispatch(setNextClasses([]));
        await dispatch(handleSetCalendarScreen(activeScreen, atualDate, atualDate, true));
        break;
      default:
        break;
    }
  };

  const onDateClick = async (day) => {
    const activeScreen = "list";
    const getSchedulesObj = {
      activeScreen,
      selectedStart: day.clone().startOf("day"),
      selectedEnd: day.clone().endOf("day"),
    };
    await dispatch(getNextClass());
    setFilter({
      startAt: getSchedulesObj.selectedStart,
      endAt: getSchedulesObj.selectedEnd,
      lingoLanguageId: "",
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
    dispatch(handleSetCalendarScreen(activeScreen, "", "", true));
  };

  const onScheduleClick = (e, scheduleId) => {
    e.stopPropagation();
    navigate(`/class-details/${scheduleId}`);
  };

  const onSchedulesClick = async (e, day, languageId, dateTime) => {
    e.stopPropagation();
    const activeScreen = "list";
    const getSchedulesObj = {
      selectedStart: day.clone(),
      selectedEnd: dateTime ? day.clone() : day.clone().endOf("day"),
    };

    await dispatch(getNextClass());
    dispatch(handleSetCalendarScreen(activeScreen, "", "", true));
    setFilter({
      startAt: getSchedulesObj.selectedStart,
      endAt: getSchedulesObj.selectedEnd,
      lingoLanguageId: languageId,
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
  };

  const nextDate = async () => {
    let time = activeScreen === "list" ? "day" : activeScreen;
    const newSelectedStart = moment(filter.startAt).add(1, time);
    const newSelectedEnd = moment(filter.endAt).add(1, time);
    const getSchedulesObj = {
      selectedStart: newSelectedStart,
      selectedEnd: newSelectedEnd,
      selectedDateTime: "",
      activeScreen,
    };
    await dispatch(
      applyCalendarFilters(
        {
          startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
          endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
          lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
          planId: "",
          type: "",
          status: "",
          student: "",
          teacher: "",
        },
        activeScreen,
        activeScreen === "list" ? true : activeScreen === "day" ? true : false,
      ),
    );
    setFilter({
      startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
      endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
      lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
  };

  const prevDate = async () => {
    let time = activeScreen === "list" ? "day" : activeScreen;
    const newSelectedStart = moment(filter.startAt).subtract(1, time);
    const newSelectedEnd = moment(filter.endAt).subtract(1, time);
    const getSchedulesObj = {
      selectedStart: newSelectedStart,
      selectedEnd: newSelectedEnd,
      selectedDateTime: "",
      activeScreen,
    };
    dispatch(
      applyCalendarFilters(
        {
          startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
          endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
          lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
          planId: "",
          type: "",
          status: "",
          student: "",
          teacher: "",
        },
        activeScreen,
        activeScreen === "list" ? true : activeScreen === "day" ? true : false,
      ),
    );
    setFilter({
      startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
      endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
      lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
  };

  const handleAtualDate = async () => {
    const newSelectedStart =
      activeScreen === "list"
        ? atualDate.startOf("day")
        : activeScreen === "day"
        ? atualDate.startOf("day")
        : activeScreen === "week"
        ? atualDate.startOf("week")
        : atualDate.startOf("month");
    const newSelectedEnd =
      activeScreen === "list"
        ? atualDate.endOf("day")
        : activeScreen === "day"
        ? atualDate.endOf("day")
        : activeScreen === "week"
        ? atualDate.endOf("week")
        : atualDate.endOf("month");
    const getSchedulesObj = {
      selectedStart: newSelectedStart,
      selectedEnd: newSelectedEnd,
      selectedDateTime: "",
      activeScreen,
    };
    dispatch(
      applyCalendarFilters(
        {
          startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
          endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
          lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
          planId: "",
          type: "",
          status: "",
          student: "",
          teacher: "",
        },
        activeScreen,
        activeScreen === "list" ? true : activeScreen === "day" ? true : false,
      ),
    );
    setFilter({
      startAt: getSchedulesObj.selectedStart.format("YYYY-MM-DD"),
      endAt: getSchedulesObj.selectedEnd.format("YYYY-MM-DD"),
      lingoLanguageId: getSchedulesObj.selectedLingoLanguageId,
      planId: "",
      type: "",
      status: "",
      student: "",
      teacher: "",
    });
  };

  const calendarRender = () => {
    const calendarObj = {
      selectedStart: nextClassesWA?.length ? moment(nextClassesWA?.scheduledDate) : selectedStart,
      selectedEnd: selectedEnd,
      schedules: nextClassesWA,
      atualDate: nextClassesWA?.length ? moment(nextClassesWA?.scheduledDate) : atualDate,
      onDateClick,
      onScheduleClick,
      onSchedulesClick,
      activeScreen,
    };
    switch (activeScreen) {
      case "month":
        return <MonthCalendar calendarObj={calendarObj} />;
      case "week":
        return <WeekCalendar calendarObj={calendarObj} />;
      case "day":
        return <DayCalendar calendarObj={calendarObj} />;
      case "list":
        return <ListCalendar calendarObj={calendarObj} />;
      default:
        break;
    }
  };

  const calendarHeaderObj = {
    nextDate,
    prevDate,
    handleAtualDate,
    selectedStart: nextClassesWA ? moment(nextClassesWA?.scheduledDate) : selectedStart,
    selectedEnd: nextClassesWA ? moment(nextClassesWA?.scheduledDate) : selectedEnd,
    viewHandler,
    activeScreen,
    selectedDateTime,
  };

  const isList = activeScreen === "list";
  const isStudent = user?.role === "student";
  const isManager = user?.role === "companyManager" || user?.role === "customerService" || user?.role === "coordinator";

  const typeOptions = [
    { name: "First Class", id: "firstclass" },
    { name: "Demo Class", id: "demo" },
    { name: "Regular", id: "regular" },
  ];

  const statusOptions = ["Pending", "Confirmed", "No Show", "Canceled", "Done"]?.map((option, i) => ({
    id: i,
    name: option,
  }));

  const filters = [
    {
      type: "date",
      name: "startAt",
      placeholder: "Select",
      label: "PERIOD_START",
      value: filter.startAt,
    },
    isList && {
      type: "date",
      name: "endAt",
      label: "PERIOD_END",
      value: filter.endAt,
      placeholder: "Select",
    },
    {
      type: "lingoLanguages",
      placeholder: "Select",
      name: "lingoLanguageId",
      label: "Native Language",
      value: filter.lingoLanguageId,
    },
    {
      name: "type",
      type: "select",
      label: "TYPE",
      value: filter.type,
      options: typeOptions,
      placeholder: "Select",
    },
    {
      name: "status",
      type: "status",
      label: "Status",
      value: filter.status,
      options: statusOptions,
      placeholder: "Select",
    },
    { name: "teacher", value: filter.teacher, label: "TEACHER", placeholder: "TEACHER_NAME", type: "text" },
    filter.type !== "demo" && {
      name: "student",
      value: filter.student,
      label: "STUDENT",
      placeholder: "STUDENT_NAME",
      type: "text",
    },
  ];

  return (
    <>
      <div className="new-container">
        <div className="calendar">
          {openSchedule && <ModalSchedule openSchedule={openSchedule} closeSchedule={handleCloseSchedule} />}
          {isManager && (
            <Filter filters={filters} inputChange={inputChange} submit={applyFilters} clear={clearFilters} />
          )}
          <CalendarHeader calendarHeaderObj={calendarHeaderObj} />
          {calendarRender()}
        </div>
        {isStudent && (
          <div className="buttonCenterBox">
            <ButtonSchedule justSchedule={true} openSchedule={handleOpenSchedule} />
          </div>
        )}
      </div>
      {!isManager && (
        <div className="nextHome">
          <div className="content">
            <NextClass />
          </div>
        </div>
      )}
    </>
  );
}

export default CalendarIndex;
